module.exports = __webpack_public_path__ + "static/media/posts-4.160edf72.jpg";